import { DDSBodyText } from "@web-monorepo/dds";
import styles from "./Author.module.css";

type AuthorProps = {
  photo: string;
  name: string;
};

export default function Author({ photo, name }: AuthorProps) {
  return (
    <div className={styles.author}>
      <img className={styles.photo} src={photo} alt="" />
      {/* `--body-md-heavy-font` + `--content-primary` is exactly what
          `<DDSBodyText variant="primary">` renders — use the primitive
          rather than a styled <div>; .name keeps just the margins. */}
      <DDSBodyText variant="primary" className={styles.name}>
        {name}
      </DDSBodyText>
    </div>
  );
}
